<template>
  <a-card style="width: 100%;margin-bottom: 10px;position: relative" >
    <p style="text-align: center;font-weight: bold;font-size: 24px">第{{customInfo.serialNumber}}集</p>
    <video :ref="'vueRef' + customInfo.id" id="vueRef" :src="customInfo.videoUrl || ''" style="width:80%;;" controls></video>
    <p >中文字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="1"  @change="change"></gatherUploadBtn>
    </p>
    <p>英文字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="2" @change="change"></gatherUploadBtn>
    </p>
    <p>西班牙语:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="3" @change="change"></gatherUploadBtn>
    </p>

    <p>泰文字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="4" @change="change"></gatherUploadBtn>
    </p>

    <p>俄文字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="5" @change="change"></gatherUploadBtn>
    </p>
    <p>
      商品类型:
      <a-select placeholder="请选择商品类型" style="width: 80px" allow-clear @change="selectType" :value="customInfo.goodsType">
        <a-select-option :value="-1">无商品</a-select-option>
        <a-select-option :value="0">商品</a-select-option>
        <a-select-option :value="1">shopify商品</a-select-option>
      </a-select>
    </p>
    <p v-if="customInfo.goodsType === 0">
      选择商品:
      <a-select
        v-model="customInfo.goodsId"
        showSearch
        style="width: 80px"
        placeholder="请选择商品"
        @change="selectGoods"
        allow-clear
        optionFilterProp="children"
      >
        <a-select-option :value="item.id" :key="item.id" :title="item.goodsName" v-for="(item,index) in goodsList">
          {{ item.goodsName }}
        </a-select-option>
      </a-select>
    </p>
    <p v-if="customInfo.goodsType === 1">
      选择商品:
      <a-select
        v-model="customInfo.shopifyGoodsId"
        showSearch
        style="width: 80px"
        placeholder="请选择商品"
        @change="selectShopifyGoods"
        allow-clear
        optionFilterProp="children"
      >
        <a-select-option :value="item.id" :key="item.id" :title="item.goodsName" v-for="(item,index) in shopifyGoodsList">
          {{ item.goodsName }}
        </a-select-option>
      </a-select>
    </p>
    <a-checkbox @change="onChange" :checked="checked" style="position: absolute;right: 5px;top: 5px">
    </a-checkbox>
  </a-card>
</template>

<script>
import {updateGather} from "@/api/video/gather";
import gatherUploadBtn from "./gatherUploadBtn";
export default {
  name: "gatherUpload",
  components:{
    gatherUploadBtn
  },
  props:{
    customInfo:{
      type:Object,
    },
    customIndex:{
      type:Number
    },
    checked:{
      type:Boolean
    },
    goodsList:{
      type:Array
    },
    shopifyGoodsList:{
      type:Array
    }
  },
  data() {
    return {
      selectedType: null
    }
  },
  methods:{
    // 选择shopify商品
    selectShopifyGoods(value) {
      console.log('选择shopify商品id:', value)
      this.customInfo.goodsId = null
      this.customInfo.shopifyGoodsId = value
      updateGather(this.customInfo).then(res => {
        console.log('1111111111111', res)
      })
    },
    // 选择商品
    selectGoods(value) {
      console.log('选择商品id:', value)
      this.customInfo.goodsId = value
      this.customInfo.shopifyGoodsId = null
      updateGather(this.customInfo).then(res => {
        console.log('22222222222222', res)
      })
    },
    // 选择商品类型
    selectType(value) {
      console.log('选中的商品类型值：', value);
      this.customInfo.goodsType = value;
      if (value === -1) {
        this.customInfo.goodsId = null;
        this.customInfo.shopifyGoodsId = null;
        updateGather(this.customInfo).then(res => {
          console.log('1111111111111', res)
        })
      }
    },
    change() {
      this.$emit("change")
    },
    onChange(e) {
      console.log(e.target.checked);
      this.$emit("selectOption",{
        checked:e.target.checked,
        id:this.customInfo.id,
        data:this.customInfo
      })
    }
  }
}
</script>

<style scoped>

</style>